import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { RadioBullet } from '../../common/radio-bullet';
import { SecondaryButton } from '../../common/secondary-button';
import { SimpleButton } from '../../common/simple-button';
import { WindowHelper } from '../../helpers/WindowHelper';
import { AddressStore } from '../../stores/AddressStore';
import { AddressList } from './address-list';
import { FeatureV2Selector } from '../../common/feature-v2-selector';
import styles from './ChooseAddress.css';

const IPropTypes = {
  onAddressSelection: PropTypes.func,
  onPickupSelection: PropTypes.func,
};

const defaultProps = {
  onAddressSelection: () => {},
  onPickupSelection: () => {},
};

const ADDRESS_FLOW = {
  SHIPPING: 'shipping',
  PICK_UP: 'pickUp',
};

const SCROLL_OFFSET = 80;

class ChooseAddress extends React.Component {
  static scrollToCreateAddress(createAddress) {
    if (!createAddress) {
      return;
    }
    WindowHelper.scrollTo({
      left: 0,
      top: createAddress.offsetTop - SCROLL_OFFSET,
      behavior: 'smooth',
    });
  }

  constructor(props) {
    super(props);
    this.state = {
      flow: ADDRESS_FLOW.SHIPPING,
      createAddressVisible: false,
    };
    this._showCreateAddressSection = this._showCreateAddressSection.bind(this);
  }
  componentDidMount() {
    AddressStore.getUserAddresses();
  }

  _updateFlowType(flowType) {
    this.setState({
      flow: flowType,
      // When changing the flow, always hide create address form
      createAddressVisible: false,
    });
  }

  _showCreateAddressSection() {
    this.setState({
      createAddressVisible: true,
    });
  }

  render() {
    return (
      <div className={styles.container}>
        <div className={styles.flowSelectionSection}>
          <h1 className={styles.title}>
            Dirección de envío
          </h1>
          <div className={styles.radioBulletContainer}>
            <RadioBullet
              className={styles.radioBullet}
              onClick={() => this._updateFlowType(ADDRESS_FLOW.SHIPPING)}
              text="Envío a domicilio o agencia"
              selected={this.state.flow === ADDRESS_FLOW.SHIPPING}
            />
            <RadioBullet
              className={styles.radioBullet}
              onClick={() => this._updateFlowType(ADDRESS_FLOW.PICK_UP)}
              text="Retiro en depósito (Montevideo)"
              selected={this.state.flow === ADDRESS_FLOW.PICK_UP}
            />
          </div>
          {
            this.state.flow === ADDRESS_FLOW.SHIPPING &&
            <p className={styles.subtext}>
              Selecciona una de tus direcciones o
              <button
                className={styles.newAddressLink}
                onClick={this._showCreateAddressSection}
              >
                ingresa una nueva dirección.
              </button>
            </p>
          }
        </div>
        {
          this.state.flow === ADDRESS_FLOW.SHIPPING &&
          <div>
            <AddressList
              className={styles.addressList}
              onSelection={this.props.onAddressSelection}
            />
            {
              !this.state.createAddressVisible &&
              <SimpleButton
                className={styles.newAddressButton}
                onClick={this._showCreateAddressSection}
              >
                Crear Nueva Dirección
              </SimpleButton>
            }
            {
              this.state.createAddressVisible &&
              <FeatureV2Selector
                feature="addressv2-users-enabled"
                component="address-form"
                reference={ChooseAddress.scrollToCreateAddress}
                onAddressCreation={this.props.onAddressSelection}
              />
            }
          </div>
        }
        {
          this.state.flow === ADDRESS_FLOW.PICK_UP &&
          <div>
            <h2 className={styles.headline}>
              Locales de retiro
            </h2>
            <p className={styles.subtitle}>
              Contamos con 2 depósitos. Al finalizar
              su compra le confirmaremos vía e-mail en cuál retira:
            </p>
            <div className={styles.branchOfficeContainer}>
              <div className={styles.branchOfficeCard}>
                <h3 className={styles.branchOfficeName}>
                  Colonia 1385 casi Ejido
                </h3>
                <p className={styles.branchOfficeText}>
                  Lunes a viernes de 9:00 a 19:00 hs.
                  <br />
                  Sábados de 9:00 a 13:00 hs.
                </p>
                <p className={styles.branchOfficeTextBold}>
                  Se retiran pequeños electrodomésticos, productos de electrónica y
                  televisores hasta 43&quot;
                </p>
              </div>
              <div className={styles.branchOfficeCard}>
                <h3 className={styles.branchOfficeName}>
                  Nicaragua 1679 casi Batoví
                </h3>
                <p className={styles.branchOfficeText}>
                  Lunes a viernes de 9:00 a 19:00 hs.
                  <br />
                  Sábados de 9:00 a 13:00 hs.
                </p>
                <p className={styles.branchOfficeTextBold}>
                  Se retiran todo tipo de productos, a excepción de algunos pequeños
                  productos de electrónica
                </p>
              </div>
            </div>
            <div className={styles.continueButtonContainer}>
              <SecondaryButton
                className={styles.continueButton}
                onClick={this.props.onPickupSelection}
              >
                Continuar
              </SecondaryButton>
            </div>
          </div>
        }
      </div>
    );
  }
}

ChooseAddress.propTypes = IPropTypes;
ChooseAddress.defaultProps = defaultProps;

const ObservedChooseAddress = observer(ChooseAddress);

export { ObservedChooseAddress as ChooseAddress };



// WEBPACK FOOTER //
// ./src/pages/choose-address/ChooseAddress.jsx